// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#DocumentInformation_component {
  background-color: #F4F4F4;
  width: 30%;
  padding: 0 20px;
  padding-top: 15px;
  position: fixed;
  right: 0;
  height: 100%;
  overflow: auto;
  padding-bottom: 100px;
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
}
#DocumentInformation_component img {
  width: 100px;
}
@media all and (min-width: 0px) and (max-width: 600px) {
  #DocumentInformation_component {
    display: none;
    height: 30%;
    top: 70%;
    width: 100%;
  }
}
#DocumentInformation_component h2 {
  text-align: center;
  padding: 6px 2px;
}
#DocumentInformation_component .choose_message {
  margin-top: 50px;
  text-align: center;
  font-size: 30px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
#DocumentInformation_component .choose_message span {
  font-size: 40px;
}
#DocumentInformation_component .link_to_detail a {
  background-color: transparent;
  display: inline-block;
  color: #9A9696;
  border: none;
  text-align: center;
  font-size: 13px;
  line-height: 8px;
  padding: 0px 10px;
  text-decoration: none;
}
#DocumentInformation_component .link_to_detail a img {
  width: 40px;
}
#DocumentInformation_component .details {
  padding: 6px 6px;
}
#DocumentInformation_component .document-details-card {
  background-color: white;
  margin-bottom: 10px;
  border-radius: 15px;
  padding-bottom: 10px;
  font-size: 13px;
}
#DocumentInformation_component .document-details-card h2 {
  text-transform: uppercase;
  text-align: left !important;
  background-color: #727272;
  color: white;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  padding: 5px 15px;
  font-size: 18px;
}
#DocumentInformation_component .document-details-card .border-right {
  border-right: 1px solid #ddd;
}
#DocumentInformation_component .document-details-card .border-right:last-child {
  border-right: none;
}`, "",{"version":3,"sources":["webpack://./src/css/documentation/document_information.scss"],"names":[],"mappings":"AASA;EACI,yBAAA;EAMA,UAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,QAAA;EACA,YAAA;EACA,cAAA;EACA,qBAAA;EACA,4BAAA;EACA,+BAAA;AAbJ;AAAI;EACI,YAAA;AAER;AAYI;EAlBJ;IAmBQ,aAAA;IACA,WAAA;IACA,QAAA;IACA,WAAA;EATN;AACF;AAWI;EACI,kBAAA;EACA,gBAAA;AATR;AAYI;EACI,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AAVR;AAYQ;EACI,eAAA;AAVZ;AAkBQ;EACI,6BAAA;EACA,qBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;AAhBZ;AAkBY;EACI,WAAA;AAhBhB;AAqBI;EACI,gBAAA;AAnBR;AAsBI;EACI,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,oBAAA;EACA,eA5EY;AAwDpB;AAqBQ;EACI,yBAAA;EACA,2BAAA;EACA,yBAAA;EACA,YAAA;EACA,4BAAA;EACA,6BAAA;EACA,iBAAA;EACA,eAAA;AAnBZ;AAsBQ;EACI,4BAAA;AApBZ;AAsBY;EACI,kBAAA;AApBhB","sourcesContent":["$color_red_1: #FF9AA2;\n$color_red_2: #FFB7B2;\n$color_orange: #FFDAC1;\n$color_grass: #E2F0CB;\n$color_green: #B5EAD7;\n$color_purlple: #C7CEEA;\n$blue_link: #5673f8;\n$font_size_content: 13px;\n\n#DocumentInformation_component {\n    background-color: #F4F4F4;\n\n    img {\n        width: 100px;\n    }\n\n    width: 30%;\n    padding: 0 20px;\n    padding-top: 15px;\n    position: fixed;\n    right: 0;\n    height: 100%;\n    overflow: auto;\n    padding-bottom: 100px;\n    border-top-left-radius: 15px;\n    border-bottom-left-radius: 15px;\n\n    @media all and (min-width:0px) and (max-width: 600px) {\n        display: none;\n        height: 30%;\n        top: 70%;\n        width: 100%;\n    }\n\n    h2 {\n        text-align: center;\n        padding: 6px 2px;\n    }\n\n    .choose_message {\n        margin-top: 50px;\n        text-align: center;\n        font-size: 30px;\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n\n        span {\n            font-size: 40px;\n        }\n    }\n\n    .link_to_detail {\n\n        // float: right;\n        //margin-right: 5px;\n        a {\n            background-color: transparent;\n            display: inline-block;\n            color: #9A9696;\n            border: none;\n            text-align: center;\n            font-size: 13px;\n            line-height: 8px;\n            padding: 0px 10px;\n            text-decoration: none;\n\n            img {\n                width: 40px;\n            }\n        }\n    }\n\n    .details {\n        padding: 6px 6px;\n    }\n\n    .document-details-card {\n        background-color: white;\n        margin-bottom: 10px;\n        border-radius: 15px;\n        padding-bottom: 10px;\n        font-size: $font_size_content;\n        h2 {\n            text-transform: uppercase;\n            text-align: left !important;\n            background-color: #727272;\n            color: white;\n            border-top-left-radius: 15px;\n            border-top-right-radius: 15px;\n            padding: 5px 15px;\n            font-size: 18px;\n        }\n\n        .border-right {\n            border-right: 1px solid #ddd;\n\n            &:last-child {\n                border-right: none;\n            }\n        }\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
